import { TranslationKey } from '~/lib/data-contract';
import { SalesforceProduct } from '../types';
import { isFreightByCarrier } from './shipping';

export type StockLabelTone = 'green' | 'grey' | 'red' | 'yellow';

export type StockLabel = {
    key: TranslationKey;
    tone: StockLabelTone;
    isTextGrey?: boolean;
};

/** Below this many units left, the remaining stock is worth calling out. */
export const LOW_STOCK_THRESHOLD = 3;

/**
 * We do not have a field for "remaining stock in online store", so we derive it from the product's
 * c_persuasiveText property instead.
 */
export const extractRemainingStockFromText = (persuasiveText?: string): number | undefined => {
    const remaining = parseInt(persuasiveText ?? '', 10);

    if (Number.isNaN(remaining) || remaining <= 0) return undefined;

    return remaining;
};

export const canDeliverProductToStore = (product: SalesforceProduct) => {
    const hasOnlineStock = product.c_in_stock_web === true;
    const hasStoreStock = product.c_in_stock_store === true;

    // Carrier freight cannot be delivered to store.
    const hasCarrierFreight = isFreightByCarrier(product.c_itemFreightGroup);

    // Store delivery only when online stock can fulfill it.
    return hasOnlineStock && !hasStoreStock && !hasCarrierFreight;
};
